"use client";

import classNames from "classnames";
import { FC } from "react";

import styles from "./loader.module.scss";
import { LoaderProps } from "./loader.types";

const Loader: FC<LoaderProps> = ({ size, border, theme = "dark", className }) => {
  return (
    <div
      className={classNames(styles.loader, styles[theme], className)}
      style={{ borderWidth: border, width: size, height: size }}
    />
  );
};

export { Loader };
